import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { RewardService } from '../service/reward.service';
import { rewardSystemActions } from './reward-system.actions';
import { of, switchMap } from 'rxjs';
import { catchError, filter, map } from 'rxjs/operators';
import { Feature, FeatureService } from '@fitup-monorepo/core/lib/services/features/feature.service';

@Injectable()
export class RewardSystemEffects {
  private readonly actions$ = inject(Actions);
  private readonly rewardService = inject(RewardService);
  private readonly featureService = inject(FeatureService);

  public readonly loadOverview$ = createEffect(() =>
    this.actions$.pipe(
      ofType(rewardSystemActions.loadCoinOverview),
      filter(() => this.featureService.isVisible(Feature.rewards)),
      switchMap(() =>
        this.rewardService.getOverview().pipe(
          map(overview => rewardSystemActions.loadCoinOverviewSuccess({ overview })),
          catchError(error => of(rewardSystemActions.loadCoinOverviewFailure({ error })))
        )
      )
    )
  );
}
